import React from 'react';
import { Box, Card, Stack, Typography, Chip } from '@mui/material';
import { ChevronRight, EventAvailableOutlined } from '@mui/icons-material';
import dayjs from 'dayjs';
import { ButtonUI } from '../../Interface';

const EmployeeAbsenceRequestList = ({ requests, onSelect, onCreate, getStatusData }) => {
  return (
    <>
      <ButtonUI text="Új szabadásigénylés" className="bg-primary" onClick={onCreate} />
      {requests.length > 0 ? (
        <Stack spacing={1.5} mt={2}>
          {requests.map((request) => {
            const statusData = getStatusData(request.approvalStatus);

            const days = dayjs(request.endDate).diff(dayjs(request.startDate), 'day') + 1;

            return (
              <Card
                key={request.id}
                onClick={() => onSelect(request)}
                sx={{
                  p: 2,
                  borderRadius: 2,
                  cursor: 'pointer',
                  border: '1px solid #EDF0F4',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                }}
              >
                <Stack
                  direction={{ xs: 'column-reverse', sm: 'row' }}
                  justifyContent={{ xs: 'flex-start', sm: 'space-between' }}
                  alignItems={{ xs: 'flex-start', sm: 'center' }}
                  spacing={1}
                >
                  <Typography fontWeight={600} fontSize={14}>
                    {dayjs(request.startDate).format('YYYY. MM. DD.')} –{' '}
                    {dayjs(request.endDate).format('YYYY. MM. DD.')}
                  </Typography>

                  <Chip
                    label={statusData?.label}
                    size="small"
                    sx={{
                      bgcolor: statusData?.colorBgCode,
                      color: statusData?.textColor,
                      fontWeight: 600,
                    }}
                  />
                </Stack>

                <Stack direction="row" justifyContent="space-between" alignItems="center" mt={1}>
                  <Box>
                    <Typography fontSize={14} color="text.secondary">
                      {days} nap
                    </Typography>
                    <Typography fontSize={14} color="text.secondary">
                      Létrehozva: {dayjs(request.createdAt).format('YYYY. MM. DD.')}
                    </Typography>
                  </Box>
                  <ChevronRight sx={{ color: '#64748B' }} />
                </Stack>
              </Card>
            );
          })}
        </Stack>
      ) : (
        <Stack
          alignItems="center"
          justifyContent="center"
          spacing={1.5}
          sx={{
            minHeight: 300,
            textAlign: 'center',
            px: 2,
          }}
        >
          <Box
            sx={{
              width: 72,
              height: 72,
              borderRadius: '50%',
              bgcolor: '#E7F3FD',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <EventAvailableOutlined
              sx={{
                fontSize: 36,
                color: '#1682FF',
              }}
            />
          </Box>

          <Typography fontSize={16} fontWeight={600} color="text.primary">
            Még nincs rögzített szabadásigénylés!
          </Typography>
        </Stack>
      )}
    </>
  );
};

export default EmployeeAbsenceRequestList;
